var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 28,
    fill: "none",
    className: "social-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linkedin",
    clipPath: "url(#clip0_3601_1144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "currentColor",
    d: "M24.14.76H1.85A1.9 1.9 0 0 0 0 2.7v23.1a1.9 1.9 0 0 0 1.85 1.96h22.3A1.9 1.9 0 0 0 26 25.8V2.7A1.9 1.9 0 0 0 24.14.75ZM7.86 23.9H4V11h3.86v12.9ZM5.93 9.25A2.28 2.28 0 0 1 3.7 6.93c0-1.27 1-2.32 2.23-2.32a2.28 2.28 0 0 1 2.24 2.32c0 1.29-1 2.32-2.24 2.32ZM22.3 23.9h-3.85v-6.27c0-1.5-.03-3.42-2-3.42-2.01 0-2.32 1.63-2.32 3.31v6.38h-3.85V11h3.7v1.76h.05a4.03 4.03 0 0 1 3.65-2.08c3.9 0 4.62 2.67 4.62 6.15v7.06Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3601_1144"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 .76h26v27H0z"
  })))));
};
export default SvgLinkedin;